import { IonSearchbar } from "@ionic/react";
import { useDispatch, useSelector } from "react-redux";

import { RootState } from "../../../store/rootReducer";
import { setSelectedSearchText } from "../../../store/userProfileLocation";

export const LocationSelectedSearchBar = () => {
    const dispatch = useDispatch();
    const selectedSearchText = useSelector((state: RootState) => state.userProfileLocation.selectedSearchText);

    return (
        <IonSearchbar
            value={selectedSearchText}
            onIonChange={({ detail: { value = "" } }) => {
                dispatch(setSelectedSearchText(value));
            }}
            debounce={700}
            placeholder={"Buscar en plantas seleccionadas..."}
            autocomplete="off"
        />
    );
};